import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const WarningTriangleIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path d="M12 9v4" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
    <path d="M12 17h.01" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
  </svg>
);

WarningTriangleIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(WarningTriangleIcon);
